import axios from 'axios';
import { Manufacturer, ManufacturerListResponse, ManufacturerUserLink } from './types';

const API_URL = process.env.REACT_APP_API_URL;

export async function listManufacturers(filter: { search?: string; enabled?: boolean; take?: number; skip?: number }): Promise<ManufacturerListResponse> {
  const params: Record<string, unknown> = {};
  if (filter.search) params.search = filter.search;
  if (filter.enabled !== undefined) params.enabled = filter.enabled;
  if (filter.take !== undefined) params.take = filter.take;
  if (filter.skip !== undefined) params.skip = filter.skip;
  const { data } = await axios.get<{ data: ManufacturerListResponse }>(`${API_URL}/admin/manufacturers`, { params });
  return data.data;
}

export async function getManufacturer(id: number): Promise<Manufacturer> {
  const { data } = await axios.get<{ data: Manufacturer }>(`${API_URL}/admin/manufacturers/${id}`);
  return data.data;
}

export async function createManufacturer(input: {
  name: string;
  contact_email?: string | null;
  contact_phone?: string | null;
  notes?: string | null;
  enabled?: boolean;
}): Promise<Manufacturer> {
  const { data } = await axios.post<{ data: Manufacturer }>(`${API_URL}/admin/manufacturers`, input);
  return data.data;
}

export async function updateManufacturer(id: number, patch: {
  name?: string;
  contact_email?: string | null;
  contact_phone?: string | null;
  notes?: string | null;
  enabled?: boolean;
}): Promise<Manufacturer> {
  const { data } = await axios.put<{ data: Manufacturer }>(`${API_URL}/admin/manufacturers/${id}`, patch);
  return data.data;
}

export async function listManufacturerUsers(id: number): Promise<ManufacturerUserLink[]> {
  const { data } = await axios.get<{ data: ManufacturerUserLink[] }>(`${API_URL}/admin/manufacturers/${id}/users`);
  return data.data;
}

export async function addManufacturerUser(manufacturer_id: number, user_id: number): Promise<void> {
  await axios.post(`${API_URL}/admin/manufacturers/${manufacturer_id}/users`, { user_id });
}

export async function removeManufacturerUser(manufacturer_id: number, user_id: number): Promise<void> {
  await axios.delete(`${API_URL}/admin/manufacturers/${manufacturer_id}/users/${user_id}`);
}

export async function createManufacturerUser(manufacturer_id: number, input: {
  name: string;
  email: string;
  document_number: string;
  password: string;
}): Promise<{ user_id: number; email: string }> {
  const { data } = await axios.post<{ data: { user_id: number; email: string } }>(
    `${API_URL}/admin/manufacturers/${manufacturer_id}/users/create`,
    input,
  );
  return data.data;
}
